module.exports = __webpack_public_path__ + "media/images/country_flags/vu-d30d8c85ea710f2fa2858a42b50eb7b8.png";